// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-87cb2b4f] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
[data-v-87cb2b4f] .app-settings__navigation {
  min-width: 200px;
  margin-right: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
[data-v-87cb2b4f] .app-settings__content {
  box-sizing: border-box;
  padding-inline: 16px;
}
.navigation-list[data-v-87cb2b4f] {
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 12px;
}
.navigation-list__link[data-v-87cb2b4f] {
  display: flex;
  align-content: center;
  font-size: 16px;
  height: 44px;
  margin: 4px 0;
  line-height: 44px;
  border-radius: var(--border-radius-pill);
  font-weight: bold;
  padding: 0 20px;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: transparent;
  border: none;
}
.navigation-list__link[data-v-87cb2b4f]:hover, .navigation-list__link[data-v-87cb2b4f]:focus {
  background-color: var(--color-background-hover);
}
.navigation-list__link--active[data-v-87cb2b4f] {
  background-color: var(--color-primary-element-light) !important;
}
.navigation-list__link--icon[data-v-87cb2b4f] {
  padding-inline-start: 8px;
  gap: 4px;
}
.navigation-list__link-icon[data-v-87cb2b4f] {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 36px;
  max-width: 36px;
}
@media only screen and (max-width: 512px) {
.app-settings[data-v-87cb2b4f] .dialog__name {
    padding-inline-start: 16px;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppSettingsDialog-DkvJ9cKe.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+DAA+D;AACjE;AACA;EACE,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;AACA;IACI,0BAA0B;AAC9B;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-87cb2b4f] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n[data-v-87cb2b4f] .app-settings__navigation {\n  min-width: 200px;\n  margin-right: 20px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n}\n[data-v-87cb2b4f] .app-settings__content {\n  box-sizing: border-box;\n  padding-inline: 16px;\n}\n.navigation-list[data-v-87cb2b4f] {\n  height: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n  padding: 12px;\n}\n.navigation-list__link[data-v-87cb2b4f] {\n  display: flex;\n  align-content: center;\n  font-size: 16px;\n  height: 44px;\n  margin: 4px 0;\n  line-height: 44px;\n  border-radius: var(--border-radius-pill);\n  font-weight: bold;\n  padding: 0 20px;\n  cursor: pointer;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  background-color: transparent;\n  border: none;\n}\n.navigation-list__link[data-v-87cb2b4f]:hover, .navigation-list__link[data-v-87cb2b4f]:focus {\n  background-color: var(--color-background-hover);\n}\n.navigation-list__link--active[data-v-87cb2b4f] {\n  background-color: var(--color-primary-element-light) !important;\n}\n.navigation-list__link--icon[data-v-87cb2b4f] {\n  padding-inline-start: 8px;\n  gap: 4px;\n}\n.navigation-list__link-icon[data-v-87cb2b4f] {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  width: 36px;\n  max-width: 36px;\n}\n@media only screen and (max-width: 512px) {\n.app-settings[data-v-87cb2b4f] .dialog__name {\n    padding-inline-start: 16px;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
